import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';

const HashProtection = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.hash.length) {
            navigate(location.hash.substring(1));
        }
    }, [location.hash, navigate]);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};

HashProtection.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HashProtection;
